import {
  PaccCompanyCurationResultRs,
  PaccCompanyCurationScoreDto,
  PaccCompanyCurationThemeDto,
} from '@domain/rs/phs/pacc/competence/PaccCompanyCurationResultRs';
import { COMPANY_TYPE } from '@domain/constant/companyType';

export class PaccCompanyCurationScoreVO {
  type: COMPANY_TYPE;
  score: number;

  constructor(dto: PaccCompanyCurationScoreDto) {
    this.type = dto.type;
    this.score = dto.score;
  }
}

export class PaccCompanyCurationThemeVO {
  sn: number; // 테마 순번
  priority: number; // 순위
  type: COMPANY_TYPE;
  name: string; // 테마 명
  adjective: string; // 수식 어구
  thumbnailImageUid: string;

  constructor(dto: PaccCompanyCurationThemeDto) {
    this.sn = dto.sn;
    this.priority = dto.priority;
    this.type = dto.type;
    this.name = dto.name;
    this.adjective = dto.adjective;
    this.thumbnailImageUid = dto.thumbnailImageUid;
  }
}

export class PaccCompanyCurationResultVO {
  sn: number;
  comment: string;
  scores: PaccCompanyCurationScoreVO[];
  themes: PaccCompanyCurationThemeVO[];

  constructor(rs: PaccCompanyCurationResultRs) {
    this.sn = rs.sn;
    this.comment = rs.comment;
    this.scores = rs.scores?.map((dto) => new PaccCompanyCurationScoreVO(dto));
    this.themes = rs.themes?.map((dto) => new PaccCompanyCurationThemeVO(dto));
  }
}
